module.exports = __webpack_public_path__ + "img/reward-box03-sp.a7e191c5.png";